import { Method } from "../Method";
import * as Parser from "../Parser";
import * as Serializer from "../Serializer";
import { Header as RequestHeader } from "./Header";
export var Request;
(function (Request) {
    function is(value) {
        return (typeof value == "object" &&
            Object.keys(value).every(key => ["method", "url", "parameter", "search", "remote", "header", "body"].some(k => k == key)) &&
            Method.is(value.method) &&
            value.url instanceof URL &&
            typeof value.parameter == "object" &&
            Object.entries(value.parameter).every(([parameter, value]) => typeof parameter == "string" && typeof value == "string") &&
            typeof value.search == "object" &&
            Object.entries(value.search).every(([key, value]) => typeof key == "string" && typeof value == "string") &&
            (value.remote == undefined || typeof value.remote == "string") &&
            (value.header == undefined || RequestHeader.is(value.header)));
    }
    Request.is = is;
    async function to(request) {
        const r = is(request) ? request : create(request);
        const header = r.header.contentType?.startsWith("multipart/form-data")
            ? (({ contentType, ...header }) => header)(r.header)
            : r.header;
        return {
            url: r.url.toString(),
            method: r.method,
            headers: RequestHeader.to(header),
            body: ["GET", "HEAD"].some(v => v == r.method)
                ? undefined
                : await Serializer.serialize(await r.body, r.header.contentType),
        };
    }
    Request.to = to;
    function from(request) {
        const url = new URL(request.url);
        return {
            method: Method.parse(request.method) ?? "GET",
            url,
            header: RequestHeader.from(request.headers),
            parameter: {},
            search: Object.fromEntries(url.searchParams.entries()),
            body: Parser.parse(request),
            ...("cf" in request && { cloudflare: request.cf }),
        };
    }
    Request.from = from;
    function create(request) {
        let result;
        if (typeof request == "string")
            result = create({ url: request });
        else {
            const url = typeof request.url == "string" ? new URL(request.url) : request.url;
            result = {
                method: Method.parse(request.method) ?? "GET",
                url,
                parameter: request.parameter ?? {},
                search: { ...request.search, ...Object.fromEntries(url.searchParams.entries()) },
                remote: request.remote,
                header: request.header ?? {},
                body: request.body,
            };
        }
        return result;
    }
    Request.create = create;
    let Header;
    (function (Header) {
        Header.is = RequestHeader.is;
        Header.from = RequestHeader.from;
        Header.to = RequestHeader.to;
    })(Header = Request.Header || (Request.Header = {}));
})(Request || (Request = {}));
//# sourceMappingURL=index.js.map